import { Component, EventEmitter, Input, Output } from '@angular/core';

import { DeleteCardService } from './service/delete-card.service';
import { CardsStateService } from '../../services/cards-state.service';


@Component({
  selector: 'mercado-pago-delete-card-modal',
  standalone: true,
  imports: [],
  templateUrl: './delete-card-modal.component.html',
  styleUrl: './delete-card-modal.component.css'
})
export class DeleteCardModalComponent {
  @Input() card: any;
  cardLastFourDigits: string = '';
  payment_method_id: string = '';
  @Output() cardDeleted = new EventEmitter<void>();
  @Output() closeModal = new EventEmitter<void>();
  isLoading: boolean = false;

  ngOnInit() {
    if (this.card) {
      this.cardLastFourDigits = this.card.last_four_digits;
      this.payment_method_id = this.card.stripe_payment_method_id;
    }
  }

  constructor(
    private deleteCardService: DeleteCardService,
    private cardsStateService: CardsStateService
  ) {}

  deleteCard(): void {
    this.isLoading = true;
    this.deleteCardService.deletePaymentMethod(this.payment_method_id).subscribe({
      next: () => {
        this.cardsStateService.refreshCards();
        this.cardDeleted.emit();
        this.closeModal.emit();
      },
      error: (error) => {
        console.error('Error deleting card:', error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
